module.exports = __webpack_public_path__ + "static/parents_banner-81fa117119404f2bef05fa64a718e502.png";